module.exports = __webpack_public_path__ + "img/compra-legal.b299d49a.png";